<template>
  <div class="page yjzx">
    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      class="top-nav"
      :btnclass="lngBtn"
      @changeNav="changeTab"
    ></BottomNav>

    <div :class="contentClass">
      <component :is="curretTabName"></component>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import Pywx from "./Pywx";
import Xsbg from "./Xsbg";
import Ksls from "./Ksls";
import Jgrw from "./Jgrw";
import Dangan from "./Dangan";

export default {
  components: {
    BottomNav,
    "m-pywx": Pywx,
    "m-xsbg": Xsbg,
    "m-ksls": Ksls,
    "m-jgrw": Jgrw,
    "m-dangan": Dangan
  },
  data() {
    return {
      page: "yjzx",
      currentTab: 0
    };
  },
  computed: {
    ...mapState({
      mtabs: state => state.tabs.yjzx,
      yjzx: "yjzx",
      locale: "locale"
    }),
    ...mapGetters(["lngClass"]),
    tabs() {
      return this.locale ? this.mtabs.slice(0, 5) : this.mtabs;
    },
    curretTabName() {
      const tabName = this.tabs[this.currentTab].name;
      return tabName ? `m-${tabName}` : "";
    },
    contentClass() {
      return `${this.page}-tabs`;
    },
    lngBtn() {
      return this.lngClass ? "pyzz-nav lng-span" : "pyzz-nav";
    }
  },
  mounted() {},
  methods: {
    changeTab(activeNum) {
      this.currentTab = activeNum;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.yjzx {
  display: flex;
  flex-direction: column;

  .top-nav {
    position: relative;
    justify-content: start;
    width: auto;
    bottom: auto;
    left: 0;
    transform: none;
    background-color: rgba(255, 255, 255, 0.7);
  }

  .yjzx-tabs {
    flex: 1;
  }
}

.yjzx-nav {
  margin: 0;
  .icon {
    display: none;
  }
  span {
    display: inline-block;
    padding: 1rem 0;
    line-height: 1;
  }

  &.lng-span {
    span {
      padding: 1rem 0.5rem;
    }
  }
}
</style>
